import SourceIcon from "@mui/icons-material/Source";
import BuildIcon from "@mui/icons-material/Build";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import PaymentsIcon from "@mui/icons-material/Payments";
import EventNoteIcon from "@mui/icons-material/EventNote";
import GroupWorkIcon from "@mui/icons-material/GroupWork";

export const reportsMenu = [
  {
    section: "Lead & Pipeline",
    key: "source",
    label: "Source",
    path: "/reports/source",
    icon: <SourceIcon />,
  },
  {
    section: "Lead & Pipeline",
    key: "services",
    label: "Services",
    path: "/reports/services",
    icon: <BuildIcon />,
  },

  {
    section: "Lead & Pipeline",
    key: "conversions",
    label: "Conversions",
    path: "/reports/conversions",
    icon: <CompareArrowsIcon />,
  },

  {
    section: "Finance",
    key: "payments",
    label: "Payments",
    path: "/reports/payments",
    icon: <PaymentsIcon />,
  },

  {
    section: "Operations",
    key: "bookings",
    label: "Bookings",
    path: "/reports/bookings",
    icon: <EventNoteIcon />,
  },

  {
    section: "Team",
    key: "employees",
    label: "Employee Reports",
    path: "/reports/employees",
    icon: <GroupWorkIcon />,
  },
];
